<script setup>
import {ref, nextTick, onMounted} from "vue";
import ElasticChat from "@/views/search/ai/ElasticChat.vue";
import elasticAiConversationsService from "@/services/elastic-ai-conversations.service";
import Header from "@/views/search/Header.vue";
import {stripPaste} from "@/helpers/string";

const chatStarted = ref(false);
const question = ref("");
const chat = ref(null);
const historyOpened = ref(false);
const recentConversations = ref([]);

onMounted(() => {
    getRecentConversations();
});

const sendRequest = async () => {
    if (!question.value.trim()) {
        return;
    }
    chatStarted.value = true;
    await nextTick();
    chat.value.startChat(question.value);
    
    question.value = '';
};

async function openConversation(conversationId) {
    getRecentConversations();
    chatStarted.value = true;
    await nextTick();

    chat.value.openConversation(conversationId);
    historyOpened.value = false;
}

function resetChat() {
    chatStarted.value = false;
    question.value = '';
    getRecentConversations();
}

async function getRecentConversations() {
    const {data} = await elasticAiConversationsService.getRecentConversations();
    recentConversations.value = data;
}
</script>

<template>
    <section class="section-ai-chat">
        <Header/>

        <template v-if="chatStarted">
            <div class="section-ai-chat__controls">
                <div v-if="!historyOpened" class="section-ai-chat__controls__nav">
                    <a @click="resetChat" class="section-ai-chat__controls__nav__compose"></a>
                    <b-button
                        v-if="recentConversations.length"
                        class="section-ai-chat__controls__nav__history"
                        @click="historyOpened = !historyOpened"
                    ></b-button>
                </div>

                <b-collapse id="collapse-1" v-model="historyOpened">
                    <div class="section-ai-chat__plate">
                        <header class="section-ai-chat__plate__header">
                            <h5 class="heading5 heading5--secondary">Chat History</h5>

                            <b-button class="close" variant="danger" @click="historyOpened = !historyOpened"></b-button>
                        </header>

                        <ul class="section-ai-chat__plate__list">
                            <li v-for="conversation in recentConversations" :key="conversation.id">
                                <a @click="openConversation(conversation.id)">{{ conversation.title }}</a>
                            </li>
                        </ul>
                    </div>
                </b-collapse>
            </div>

            <ElasticChat
                ref="chat"
                @reset="resetChat"
            />
        </template>

        <div v-else class="ai-chat__inner">
            <div class="ai-chat__tabs__inner">
                <h5 class="heading5 heading5--secondary">Describe the startups you're looking for.</h5>

                <div class="card--ai__search">
                    <span
                        role="textbox"
                        contenteditable
                        v-focus
                        @input="question = $event.target.textContent"
                        @paste.prevent="stripPaste"
                        @keyup.enter.prevent="sendRequest"
                        placeholder="Search over 650,000 startups"
                        class="card--ai__search__input"
                    ></span>

                    <button class="card--ai__search__button" @click="sendRequest"/>
                </div>

                <div v-if="recentConversations.length">
                    <h6 class="heading6">Recent</h6>

                    <ul class="list-recent">
                        <li v-for="conversation in recentConversations.slice(0, 5)" :key="conversation.id">
                            <a @click="openConversation(conversation.id)">{{ conversation.title }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
</style>
